export const toNumberOrNull = (value: number | null | string | undefined): number | null => {
    if (value === null || value === undefined) {
        return null;
    }

    // Handle string values
    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (trimmed === '') {
            return null;
        }
        const num = Number(trimmed);
        return isNaN(num) ? null : num;
    }

    // Handle number values
    return value;
};
